import Icon, { EditOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Row, Typography } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { NotePickModal } from '../../..';
import { BookmarkOutlined } from '../../../../../assets/icons/icons';
import { AdminRoutes } from '../../../../../features/admin';
import { DisplayDateFormat } from '../../../../constants';
import { UserRoleEnum } from '../../../../enums';
import {
  DecisionInterface,
  LicenceInterface,
  NoteResponseInterfaceAll,
  SummaryInterface,
  TagScreenResponseInterface
} from '../../../../interfaces';
import { StoreStateInterface } from '../../../../redux';
import { i18n } from '../../../../services';
import DecisionsDetailsDrawer from '../../../decisionsDetailsDrawer/decisionsDetailsDrawer.component';

const { Paragraph, Text } = Typography;

interface Props {
  summary?: SummaryInterface;
  tags?: Array<TagScreenResponseInterface>;
  licenceData?: LicenceInterface;
  notes?: NoteResponseInterfaceAll;
  validLicences?: LicenceInterface[];
}

export default function DKOMSummaryCardComponent({ summary, tags, licenceData, notes, validLicences }: Props) {
  const userAuth = useSelector((state: StoreStateInterface) => state.auth);

  const [decision, setDecision] = useState<DecisionInterface['attributes']>();
  const [visible, setVisible] = useState(false);

  const availableNotes = licenceData?.attributes?.notesNum as number;

  const showModal = () => {
    setVisible(true);
  };

  const handleOk = () => {
    if (!((notes?.data.length as number) == availableNotes)) {
      setVisible(true);
    }
    setVisible(false)
  };

  const handleCancel = () => {
    setVisible(false);
  };

  useEffect(() => {
    const id = summary?.relationships?.decision?.data?.id
      ? summary?.relationships?.decision?.data?.id
      : summary?.attributes?.decision?.id;
    if (id) {
      setDecision(summary?.attributes?.decision);
      /**
      DecisionService.getSingle(id).subscribe(
        (response: any) => {
          setDecision(response.data);
        },
        (error: Error) => {
          console.log(error);
        }
      );
      */
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [summary]);

  return (
    <div className="summaryCard">
      {summary ? (
        <>
          <Row className="row">
            <Col flex={4}>
              <Text className="dateTime" type="secondary">
                {decision?.clazz} <Divider type="vertical" />{' '}
                {moment(decision?.decisionDate).format(DisplayDateFormat)}
              </Text>
            </Col>
            <Col flex={0}>
              <Button
                type="link"
                className="cardBtn"
                onClick={showModal}
                icon={<Icon component={BookmarkOutlined} />}
              />
              {userAuth.user?.roles === UserRoleEnum.ADMIN && (
                <Link
                  to={AdminRoutes.DKOM_DECISIONS.fullPath + `/${decision?.id}`}
                  key={AdminRoutes.DKOM_DECISIONS.fullPath + `/${decision?.id}`}
                >
                  <Button type="link" className="cardBtn" icon={<EditOutlined />} />
                </Link>
              )}
            </Col>
          </Row>
          <Paragraph className='para' style={{ whiteSpace: 'pre-wrap' }}>{summary?.attributes?.titleContent}</Paragraph>

          <DecisionsDetailsDrawer
            drawerTitle={i18n.translate('summarys.title')}
            decision={decision}
            data={summary}
            tags={tags}
            licenceData={licenceData}
            validLicences={validLicences}
          />

          <Divider />

          <NotePickModal
            isExternal={true}
            visible={visible}
            handleOk={handleOk}
            handleCancel={handleCancel}
            external={summary}
            type="decision_summary"
            typeId={summary?.id}
            breadcrumb={'Pravna zaštita/Praksa u RH/Odluke DKOM-a/Sažetci odluka/' + summary?.attributes?.titleContent}
            number={summary?.id}
            isEditable={true}
            active={true}
            licenceData={licenceData as LicenceInterface}
            validLicences={validLicences}
          />
        </>
      ) : null}
    </div>
  );
}
